import useValidator from '../../../../utilities/useValidator';
import validators from '../../../../utilities/validators';

const validatorUpdation = validators.compose(
    validators.requiredBoolean('isActive'),
    validators.requiredString('pageTitle.defaultValue'),
    validators.requiredString('pageSubtitle.defaultValue'),
    validators.requiredString('pageDescription.defaultValue'),
    validators.requiredString('configuratorTitle.defaultValue'),
    validators.requiredString('urlIdentifier'),
    validators.urlIdentifier('urlIdentifier')
);

const validatorCreation = validators.compose(
    validators.requiredString('modelId'),
    validators.requiredString('moduleId'),
    validatorUpdation
);

const useModelConfiguratorFormValidator = (isCreation?: boolean) =>
    useValidator(isCreation ? validatorCreation : validatorUpdation);

export default useModelConfiguratorFormValidator;
